export var createLoadingSelector = function createLoadingSelector(actions) {
  return function (state) {
    return actions.every(function (action) {
      return state.core.loading[action];
    });
  };
};